import { closest } from '@jotforminc/utils';

import DateHandler from './dateHandler';

class Datetime {
  constructor(props) {
    this.init = this.init.bind(this);
    this.updateCalendarPositions = this.updateCalendarPositions.bind(this);
    this.init(props);
    this.listenCalendarOutsideClick();
    this.listenResize();
  }

  init(props) {
    this.cards = props.cards;
    const dateCards = props.cards.filter(p => ['control_datetime', 'control_birthdate'].indexOf(p.question.type) > -1);
    const inlineQuestionsCards = props.cards.filter(p => p.question.type === 'control_inline');
    this.handlers = dateCards.map(card => new DateHandler(card, props.hasTouch, props.deviceType));
    inlineQuestionsCards.forEach(card => {
      (Array.isArray(card.question.fields) ? card.question.fields : []).filter(field => field.type === 'control_datetime').forEach(dateField => {
        this.handlers.push(new DateHandler(card, props.hasTouch, props.deviceType, dateField));
      });
    });
  }

  closeAllCalendars() {
    this.handlers.forEach(p => p.setCalendarVisibility(false));
  }

  listenCalendarOutsideClick() {
    document.addEventListener('click', e => {
      if (!closest(e.target, '.jfCalendar-container, .jfDropdown-toggle')) {
        this.handlers.forEach(p => { p.setCalendarVisibility(false); });
      }
    }, true);
  }

  updateCalendarPositions() {
    this.handlers.forEach(p => { p.updateCalendarPosition(); })
  }

  listenResize() {
    window.addEventListener('resize', () => {
      this.updateCalendarPositions();
    });

    window.addEventListener('orientationchange', () => {
      this.updateCalendarPositions();
    });
  }

  onCalendarSelected(card, date) {
    const handler = this.handlers.find(p => p.card === card);
    handler.onCalendarSelected(date);
  }

  onCalendarInit(card, calendar) {
    const handler = this.handlers.find(p => p.card === card);
    handler.calendar = calendar;
  }
}

export default Datetime;
